import { Layout } from "@/components/Layout";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Search, Calculator, FileCheck, ThumbsUp, CreditCard, ArrowRight } from "lucide-react";

const STEPS = [
  [Search, "Browse Premium Inventory", "Explore America's most in-demand vehicles with full specifications, photos, and transparent pricing."],
  [Calculator, "Estimate Your Payment", "Use our live financing calculator to model your monthly payment with flexible down payments and terms up to 48 months."],
  [FileCheck, "Apply Securely", "Sign in and complete a secure multi-step application. Upload your documents to private, encrypted storage."],
  [ThumbsUp, "Get a Decision", "Our finance team reviews your application. Track your status in real time through a visual timeline."],
  [CreditCard, "Drive & Track", "Once approved, manage your financing contract, payment schedule, and progress from your premium dashboard."],
];

export default function HowItWorks() {
  return (
    <Layout>
      <div className="border-b border-slate-200 bg-[#E3ECFB] py-16">
        <div className="container-x max-w-3xl">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-gold">Simple & Transparent</p>
          <h1 className="mt-3 font-display text-4xl font-extrabold text-slate-900 lg:text-5xl">How It Works</h1>
          <p className="mt-4 text-lg text-slate-600">From browsing to driving — five simple steps to premium vehicle financing.</p>
        </div>
      </div>
      <div className="container-x py-16">
        <div className="relative space-y-8">
          {STEPS.map(([Icon, t, d], i) => (
            <div key={t} className="card-surface flex flex-col gap-5 p-7 hover-lift sm:flex-row sm:items-center">
              <div className="flex items-center gap-5">
                <div className="font-display text-5xl font-extrabold text-slate-900/10">0{i + 1}</div>
                <div className="flex h-14 w-14 flex-shrink-0 items-center justify-center rounded-2xl gold-gradient text-[#EEF3FC]"><Icon className="h-7 w-7" /></div>
              </div>
              <div>
                <h3 className="font-display text-xl font-bold text-slate-900">{t}</h3>
                <p className="mt-1 text-slate-600">{d}</p>
              </div>
            </div>
          ))}
        </div>
        <div className="mt-12 text-center">
          <Button asChild className="btn-gold rounded-full px-10 py-6 text-base"><Link to="/inventory" data-testid="hiw-start-btn">Get Started <ArrowRight className="ml-2 h-4 w-4" /></Link></Button>
        </div>
      </div>
    </Layout>
  );
}
